/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs */

const en_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Head to Focus Sessions to earn more coins, or subscribe to Plus to accumulate coins 3x faster!`)
};

const ar_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توجه إلى جلسات التركيز لكسب المزيد من العملات، أو اشترك في Plus لتجميع العملات أسرع بثلاث مرات!`)
};

const de_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zu Fokus-Sitzungen, um mehr Münzen zu sammeln, oder abonniere Plus, um Münzen 3-mal schneller zu sammeln!`)
};

const es_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Dirígete a las Sesiones de concentración para ganar más monedas, o suscríbete a Plus para acumular monedas 3 veces más rápido!`)
};

const fr_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participez aux Sessions de concentration pour gagner plus de pièces, ou abonnez-vous à Plus pour accumuler des pièces 3 fois plus vite !`)
};

const it_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alle Sessioni di concentrazione per guadagnare più monete, oppure abbonati a Plus per accumulare monete 3 volte più velocemente!`)
};

const ja_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中セッションでコインをもっと集めるか、Plusに登録してコインの獲得スピードを3倍にしましょう！`)
};

const ko_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 세션으로 이동하여 코인을 더 모으거나 Plus를 구독하여 코인을 3배 더 빠르게 모으세요!`)
};

const pt_br_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vá para as Sessões de Foco para ganhar mais moedas ou assine o Plus para acumular moedas 3 vezes mais rápido!`)
};

const ru_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите к сеансам фокусировки, чтобы заработать больше монет, или оформите подписку Plus, чтобы накапливать монеты в 3 раза быстрее!`)
};

const th_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปที่เซสชันโฟกัสเพื่อสะสมเหรียญเพิ่ม หรือสมัคร Plus เพื่อสะสมเหรียญได้เร็วขึ้น 3 เท่า!`)
};

const tr_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla jeton kazanmak için Odaklanma Oturumlarına git veya jetonları 3 kat daha hızlı biriktirmek için Plus’a abone ol!`)
};

const zh_cn_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往专注累计更多金币，或订阅 Plus 让金币累计快三倍！`)
};

const zh_tw_dialog_not_enough_balance_sunshine_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往專注累積更多金幣，或訂閱 Plus 讓金幣累積快三倍！`)
};

/**
* | output |
* | --- |
* | "Head to Focus Sessions to earn more coins, or subscribe to Plus to accumulate coins 3x faster!" |
*
* @param {Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_balance_sunshine_description = /** @type {((inputs?: Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Balance_Sunshine_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "ar") return ar_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "de") return de_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "es") return es_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "fr") return fr_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "it") return it_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "ja") return ja_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "ko") return ko_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "ru") return ru_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "th") return th_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "tr") return tr_dialog_not_enough_balance_sunshine_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_balance_sunshine_description(inputs)
	return zh_tw_dialog_not_enough_balance_sunshine_description(inputs)
});